import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapperProps: BoxProps = {
  h: '100%',
  minW: ['unset', null, '460px'],
  maxW: ['100vw', null, null],
  display: 'flex',
  justifyContent: ['start', null, 'center'],
  fontFamily: 'Roboto',
  sx: {
    'div:first-child': {
      display: 'flex',
      flexDir: 'column',
      fontSize: 'xs',
      fontWeight: 'bold',
      alignItems: 'flex-start',
      svg: {
        boxSize: '2.5',
        mr: '1',
        mb: '0',
      },
      '.chakra-link': {
        mb: '4',
        color: 'beta.300',
        textTransform: 'unset',
        fontSize: '2xs',
        fontFamily: 'body',
      },
    },
  },
  bg: 'alpha.700',
  borderTop: ['2px', '2px', '0px'],
  borderColor: 'beta.500',
};

export const TextForgotPasswordSuccess: CSSObject = {
  color: 'white',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  fontFamily: 'body',
  mb: '2',
  '+ a': {
    display: 'none',
  },
};

export const linkLoginProps: CSSObject = {
  fontWeight: 'bold',
  color: 'beta.500',
  textTransform: 'uppercase',
  fontSize: 'xs',
};

export const ForgotPasswordButton: CSSObject = {
  textTransform: 'uppercase',
  fontSize: 'xs',
};

export const Title: CSSObject = {
  color: 'white',
  fontSize: 'xs',
};
